export default __webpack_public_path__ + "static/25-495ee6a24a73740ba9bb2b1f064c9beb.jpg";